import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    isCompanyLevel: 1, // 环保规则配置类型 1 企业 2 用户
    levelFormData: {}, // 环保配置表格信息
    logPageParams: {
      page: 1,
      pageSize: 5,
    },
    logList: [], // 日志列表
    logTotal: 0, // 日志列表总数
    logModalVisible: false, // 操作日志弹窗
    logLoading: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { EnvironmentalRule }, getState }) => ({
    // 切换等级Tab
    changelLevelType(flag) {
      EnvironmentalRule.setState({ isCompanyLevel: flag });
    },
    // 设置操作日志弹窗展开
    setLogModalVisible(flag) {
      EnvironmentalRule.setState({ logModalVisible: flag });
    },
    // 更新环保配置
    async updateEcoLevelRule(params) {
      const data = await fetch('/saasmerchant/web/eco/updateEcoLevelRule', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 获取环保规则配置信息
    async getEcoLevelRule() {
      const { isCompanyLevel } = getState().EnvironmentalRule;
      const data = await fetch('/saasmerchant/web/eco/getDbEcoLevelRule', {
        params: {
          ecoRuleType: isCompanyLevel,
        },
      });
      if (data) {
        EnvironmentalRule.setState({ levelFormData: data });
      }
      return data;
    },
    // 获取环保规则配置日志列表
    async getRulesLog() {
      const { logPageParams, isCompanyLevel, logLoading } = getState().EnvironmentalRule;
      EnvironmentalRule.setState({ logLoading: true });
      const data = await fetch('/saasmerchant/web/eco/getEcoRuleOperationLog', {
        params: {
          ecoRuleType: isCompanyLevel,
          ...logPageParams,
        },
      });
      EnvironmentalRule.setState({ logLoading: false });
      if (data) {
        EnvironmentalRule.setState({
          logList: data.list,
          logTotal: data.total,
        });
      }
    },
    changeLogPageParams(page, pageSize, isRule, shopId) {
      const { logPageParams } = getState().EnvironmentalRule;
      EnvironmentalRule.setState({ logPageParams: { ...logPageParams, page } });
      isRule ? EnvironmentalRule.getRulesLog() : EnvironmentalRule.getLevelOperationLog(shopId);
    },
    // 清空操作日志modal数据
    clearLogModal() {
      EnvironmentalRule.setState({
        logPageParams: { page: 1, pageSize: 5 },
        logList: [],
        logTotal: 0,
      });
    },
    // 修改商户环保等级
    async updateShopLevel(params) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/eco/updateEcoLevel', {
        params: {
          unionShopId: union_shop_id,
          ...params,
        },
      });
      return data;
    },
    // 获取商户等级操作日志列表
    async getLevelOperationLog(shopId) {
      const { logPageParams } = getState().EnvironmentalRule;
      EnvironmentalRule.setState({ logLoading: true });
      const data = await fetch('/saasmerchant/web/eco/levelOperationLog', {
        params: {
          shopId,
          ...logPageParams,
        },
      });
      EnvironmentalRule.setState({ logLoading: false });
      if (data) {
        EnvironmentalRule.setState({
          logList: data.list,
          logTotal: data.total,
        });
      }
    },
    // 企业数据管理导出列表
    async exportCompanylist(params) {
      const data = await fetch('/saasmerchant/web/eco/exportCompanyEcoByCondition', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('添加导出任务成功');
      }
    },
    // 企业数据管理导出列表
    async exportChieflist(params) {
      const data = await fetch('/saasmerchant/web/eco/exportCustomerGroupEcoByCondition', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('添加导出任务成功');
      }
    },
  }),
};

export default model;
